import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "receive-forecast-search" }
const _hoisted_2 = { class: "receive-forecast-search__main" }
const _hoisted_3 = { class: "receive-forecast-search__instruction" }
const _hoisted_4 = { class: "receive-forecast-search__filter-content filter-content" }
const _hoisted_5 = { class: "filter-content__item" }
const _hoisted_6 = { class: "filter-content__title" }
const _hoisted_7 = { class: "receive-forecast-search__result-content result-content" }
const _hoisted_8 = { class: "result-content__title" }
const _hoisted_9 = { class: "result-content__select-month-area select-month-area" }
const _hoisted_10 = { class: "select-month-area__title" }
const _hoisted_11 = { class: "bulk-edit-button__container" }
const _hoisted_12 = { class: "bulk-edit-button__text" }
const _hoisted_13 = { class: "fof-download" }
const _hoisted_14 = { class: "fof-download__picker-container" }
const _hoisted_15 = { class: "fof-download__picker-item" }
const _hoisted_16 = { class: "fof-download__picker-label" }

import { i18n } from '@/i18n';
import { useSearchForecastForReceiptStore } from './useSearchForecastForReceiptStore';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { IYearMonth } from '@/coreDomainsModule/date';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import ControlCustomerPageTab from '../components/ControlCustomerPageTab.vue';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { CUSTOMER_TAB_ROUTER_INFO, staffFilterTableHeaders, searchResultTableHeaders } from '../constants';
import EditForecastModal from '../components/EditForecastModal.vue';
import BulkEditConfirmModal from '../components/BulkEditConfirmModal.vue';
import { toast } from '@/corePagesModule/components/Toast/ToastManager';
import { openLoadingModal } from '@/corePagesModule/components/modal/modalActions';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { DateService } from '@/coreDomainsModule/services/dateService';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchForecastForReceipt',
  setup(__props) {

onMounted(async () => {
  await initStaffFilter();
  await initSearchResult();
});

// 変数
const tabInfos = [...CUSTOMER_TAB_ROUTER_INFO];
const t = i18n.t;
const locale = computed(() => i18n.locale);
const router = useRouter();
const store = useSearchForecastForReceiptStore();
const { state } = storeToRefs(store);

// モーダル状態（ダウンロード）
const isDownloadModalOpen = ref(false);
const downloadTargetForecastForReceiptName = ref<string | undefined>(undefined);
const downloadTargetForecastForReceiptUserId = ref<string | undefined>(undefined);
const startYearMonth = ref<IYearMonth | undefined>(undefined);

// モーダル状態（一括編集）
const isEditModalOpen = ref(false);
const isConfirmModalOpen = ref(false);
const pendingEditData = ref<{
  selectedStaffIdList: string[];
}>({ selectedStaffIdList: [] });

// モーダル状態（行編集）
const isRowEditModalOpen = ref(false);
const isRowConfirmModalOpen = ref(false);
const editingRowId = ref<string | undefined>(undefined);
const pendingRowEditData = ref<{
  selectedStaffIdList: string[];
  forecastForReceiptName?: string;
}>({ selectedStaffIdList: [], forecastForReceiptName: undefined });

/**
 * 初期化処理
 */
const initStaffFilter = async () => {
  await store.fetchStaffFilterTableContents();
  state.value.staffFilterTableContents.renderingKey += 1;
};

/**
 * 検索結果テーブルの初期化処理
 */
const initSearchResult = async () => {
  await store.fetchSearchResultTableContents();
  state.value.searchResultTableContents.renderingKey += 1;
};

const isDisabledBulkEdit = computed(() => {
  return state.value.searchResultTableContents.checkedIds.length === 0;
});

/**
 * 月選択の最小年月（10年前）
 */
const monthPickerMinDate = computed((): IYearMonth => {
  const now = new Date();
  return {
    year: now.getFullYear() - 10,
    month: now.getMonth() + 1, // IYearMonth uses 1-indexed month
  };
});

/**
 * 月選択の最大年月（当月）
 */
const monthPickerMaxDate = computed((): IYearMonth => {
  const now = new Date();
  return {
    year: now.getFullYear(),
    month: now.getMonth() + 1, // IYearMonth uses 1-indexed month
  };
});

/**
 * 一括編集ボタンをクリックした時の処理
 */
const onClickBulkEdit = () => {
  isEditModalOpen.value = true;
};

/**
 * 編集モーダルで適用をクリックした時の処理
 * @param selectedStaffIdList - 選択された担当者IDリスト
 */
const onApplyEdit = (selectedStaffIdList: string[]) => {
  pendingEditData.value = { selectedStaffIdList };
  isEditModalOpen.value = false;
  isConfirmModalOpen.value = true;
};

/**
 * 確認モーダルで保存をクリックした時の処理
 */
const onConfirmSave = async () => {
  const checkedDisplayIds = state.value.searchResultTableContents.checkedIds;
  // displayIdから実際のforecastForReceiptIdを取得
  const forecastForReceiptIds = state.value.searchResultTableContents.contentItems
    .filter((item) => checkedDisplayIds.includes(item.displayId))
    .map((item) => item.forecastForReceiptId as string)
    .filter((id): id is string => id !== undefined);
  const result = await store.bulkUpdateForecastForReceipt(forecastForReceiptIds, pendingEditData.value.selectedStaffIdList);
  isConfirmModalOpen.value = false;
  pendingEditData.value = { selectedStaffIdList: [] };
  if (result.status.type === 'success') {
    await initStaffFilter();
    await initSearchResult();
  }
};

/**
 * 確認モーダルでキャンセルをクリックした時の処理（編集モーダルに戻る）
 */
const onConfirmCancel = () => {
  isConfirmModalOpen.value = false;
  isEditModalOpen.value = true;
};

/**
 * 確認モーダルで保存せずに終了をクリックした時の処理
 */
const onConfirmDiscardAndClose = () => {
  isConfirmModalOpen.value = false;
  pendingEditData.value = { selectedStaffIdList: [] };
};

/**
 * 行の3点メニューから編集をクリックした時の処理
 * @param displayId - 編集対象の行ID
 */
const onClickRowEdit = (displayId: string) => {
  editingRowId.value = displayId;
  isRowEditModalOpen.value = true;
};

/**
 * 行編集モーダルで適用をクリックした時の処理
 * @param selectedStaffIdList - 選択された担当者IDリスト
 * @param forecastForReceiptName - 受領用内示名
 */
const onApplyRowEdit = (selectedStaffIdList: string[], forecastForReceiptName?: string) => {
  pendingRowEditData.value = { selectedStaffIdList, forecastForReceiptName };
  isRowEditModalOpen.value = false;
  isRowConfirmModalOpen.value = true;
};

/**
 * 行編集の確認モーダルで保存をクリックした時の処理
 */
const onRowConfirmSave = async () => {
  if (editingRowId.value) {
    // displayIdから実際のforecastForReceiptIdを取得
    const targetItem = state.value.searchResultTableContents.contentItems.find((item) => item.displayId === editingRowId.value);
    const forecastForReceiptId = targetItem?.forecastForReceiptId as string | undefined;
    if (forecastForReceiptId) {
      const result = await store.bulkUpdateForecastForReceipt(
        [forecastForReceiptId],
        pendingRowEditData.value.selectedStaffIdList,
        pendingRowEditData.value.forecastForReceiptName
      );
      isRowConfirmModalOpen.value = false;
      editingRowId.value = undefined;
      pendingRowEditData.value = { selectedStaffIdList: [], forecastForReceiptName: undefined };
      if (result.status.type === 'success') {
        await initStaffFilter();
        await initSearchResult();
      }
    }
  }
};

/**
 * 行編集の確認モーダルでキャンセルをクリックした時の処理（編集モーダルに戻る）
 */
const onRowConfirmCancel = () => {
  isRowConfirmModalOpen.value = false;
  isRowEditModalOpen.value = true;
};

/**
 * 行編集の確認モーダルで保存せずに終了をクリックした時の処理
 */
const onRowConfirmDiscardAndClose = () => {
  isRowConfirmModalOpen.value = false;
  editingRowId.value = undefined;
  pendingRowEditData.value = { selectedStaffIdList: [], forecastForReceiptName: undefined };
};

/**
 * 担当者テーブルのダウンロードをクリックした時の処理
 * @param displayId - 対象の行ID
 */
const onClickStaffDownload = (displayId: string) => {
  const targetItem = state.value.staffFilterTableContents.contentItems.find((item) => item.displayId === displayId);
  const forecastForReceiptResponsibleUserId = targetItem?.forecastStaffId as string | undefined;
  if (forecastForReceiptResponsibleUserId) {
    downloadTargetForecastForReceiptUserId.value = forecastForReceiptResponsibleUserId;
    isDownloadModalOpen.value = true;
  }
};

/**
 * 検索結果テーブルのダウンロードをクリックした時の処理
 * @param displayId - 対象の行ID
 */
const onClickSearchResultDownload = (displayId: string) => {
  const targetItem = state.value.searchResultTableContents.contentItems.find((item) => item.displayId === displayId);
  const forecastForReceiptResponsibleUserId = targetItem?.forecastForReceiptResponsibleUsers?.[0]?.email as string | undefined;
  const forecastForReceiptName = targetItem?.forecastForReceiptName as string | undefined;
  if (forecastForReceiptResponsibleUserId && forecastForReceiptName) {
    downloadTargetForecastForReceiptUserId.value = forecastForReceiptResponsibleUserId;
    downloadTargetForecastForReceiptName.value = forecastForReceiptName;
    isDownloadModalOpen.value = true;
  }
};

/**
 * ダウンロードモーダルを閉じる
 */
const onCloseDownloadModal = () => {
  isDownloadModalOpen.value = false;
  downloadTargetForecastForReceiptUserId.value = undefined;
  downloadTargetForecastForReceiptName.value = undefined;
  startYearMonth.value = undefined;
};

/**
 * ダウンロードモーダルで適用をクリックした時の処理
 */
const onApplyDownload = async () => {
  const confirmedStartYearMonth = startYearMonth.value;
  if (!downloadTargetForecastForReceiptUserId.value || !confirmedStartYearMonth) return;

  isDownloadModalOpen.value = false;
  const forecastForReceiptUserId = downloadTargetForecastForReceiptUserId.value;
  const forecastForReceiptName = downloadTargetForecastForReceiptName.value;

  /**
   * ダウンロード処理を実行する内部関数
   */
  const executeDownload = async () => {
    return await store.downloadForecastForReceipt(forecastForReceiptUserId, confirmedStartYearMonth, forecastForReceiptName);
  };

  const result = await openLoadingModal(t('出力中'), executeDownload, []);

  if (result) {
    toast.success(t('ダウンロードしました'));
  } else {
    toast.error(t('ダウンロードに失敗しました'));
  }

  downloadTargetForecastForReceiptUserId.value = undefined;
  downloadTargetForecastForReceiptName.value = undefined;
};

/**
 * 担当者テーブルの内示依頼メールをクリックした時の処理
 * @param displayId - 対象の行ID
 */
const onClickStaffForecastRequestMail = (displayId: string) => {
  // TODO: 内示依頼メール処理を実装
  console.log('staff forecast request mail', displayId);
};

/**
 * 検索結果テーブルの取引一覧ボタンをクリックした時の処理
 * 全取引タブに遷移し、該当の受領用内示が選択された状態で表示する
 * @param displayId - 対象の行ID
 */
const onClickTransactionList = (displayId?: string) => {
  if (!displayId) return;

  // displayIdから実際のforecastForReceiptIdを取得
  const targetItem = state.value.searchResultTableContents.contentItems.find((item) => item.displayId === displayId);
  const forecastForReceiptId = targetItem?.forecastForReceiptId as string | undefined;

  if (forecastForReceiptId) {
    // 全取引タブに遷移（受領用内示IDをパスパラメータとして渡す）
    router.push({
      name: 'customer-transaction-list',
      params: { forecastForReceiptId },
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ControlCustomerPageTab, {
        class: "receive-forecast-search__tab-bar",
        "tab-info-object": tabInfos
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('forecastForReceipt_searchInstruction')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('forecastForReceipt_searchFilterByStaff')), 1),
            (_openBlock(), _createBlock(NewBaseTableContent, {
              key: _unref(state).staffFilterTableContents.renderingKey,
              class: "filter-content__table",
              "prop-table-content-properties": _unref(staffFilterTableHeaders),
              "prop-display-objects": _unref(state).staffFilterTableContents.contentItems,
              "prop-loading-status": _unref(state).staffFilterTableContents.loadingState,
              "prop-table-type": 'forecastForReceiptStaffFilterTable',
              onChecked: _unref(store).onCheckedStaffFilterDisplayIds,
              onOnClickDownload: onClickStaffDownload,
              onOnClickForecastRequestMail: onClickStaffForecastRequestMail
            }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status", "onChecked"]))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('forecastForReceipt_searchResultTitle')), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('forecastForReceipt_searchReceiveDate')), 1),
            _createVNode(MonthPicker, {
              class: "select-month-area__calendar",
              "model-value": _unref(state).receivedForecastYearMonth,
              locale: locale.value,
              "prop-format": _unref(t)('MonthPickerFormat'),
              "min-date": monthPickerMinDate.value,
              "max-date": monthPickerMaxDate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(store).onSelectedReceiveMonth($event)))
            }, null, 8, ["model-value", "locale", "prop-format", "min-date", "max-date"]),
            _createVNode(TextButton, {
              class: _normalizeClass(["select-month-area__bulk-edit-button bulk-edit-button", { 'bulk-edit-button--enabled': !isDisabledBulkEdit.value }]),
              disabled: isDisabledBulkEdit.value,
              onClick: onClickBulkEdit
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('一括編集')), 1),
                  _createVNode(SvgLoader, {
                    class: "bulk-edit-button__icon",
                    name: "editPen"
                  })
                ])
              ], undefined, true),
              _: 1
            }, 8, ["class", "disabled"])
          ]),
          (_openBlock(), _createBlock(NewBaseTableContent, {
            key: _unref(state).searchResultTableContents.renderingKey,
            class: "result-content__table",
            "prop-table-content-properties": _unref(searchResultTableHeaders),
            "prop-display-objects": _unref(state).searchResultTableContents.contentItems,
            "prop-loading-status": _unref(state).searchResultTableContents.loadingState,
            "prop-table-type": 'forecastForReceiptSearchResultTable',
            onChecked: _unref(store).onCheckedSearchResultDisplayIds,
            onOnClickEdit: onClickRowEdit,
            onOnClickTransactionList: onClickTransactionList,
            onOnClickDownload: onClickSearchResultDownload
          }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status", "onChecked"]))
        ])
      ])
    ]),
    _createVNode(EditForecastModal, {
      "modal-state": isEditModalOpen.value,
      "select-input-index": 30,
      onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (isEditModalOpen.value = false)),
      onApply: onApplyEdit
    }, null, 8, ["modal-state"]),
    _createVNode(BulkEditConfirmModal, {
      "modal-state": isConfirmModalOpen.value,
      onSave: onConfirmSave,
      onCancel: onConfirmCancel,
      onDiscardAndClose: onConfirmDiscardAndClose
    }, null, 8, ["modal-state"]),
    _createVNode(EditForecastModal, {
      "modal-state": isRowEditModalOpen.value,
      "select-input-index": 31,
      "show-forecast-name": true,
      onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (isRowEditModalOpen.value = false)),
      onApply: onApplyRowEdit
    }, null, 8, ["modal-state"]),
    _createVNode(BulkEditConfirmModal, {
      "modal-state": isRowConfirmModalOpen.value,
      onSave: onRowConfirmSave,
      onCancel: onRowConfirmCancel,
      onDiscardAndClose: onRowConfirmDiscardAndClose
    }, null, 8, ["modal-state"]),
    _createVNode(InfoModal, {
      "modal-state": isDownloadModalOpen.value,
      "back-button-label": _unref(t)('もどる'),
      "next-button-label": _unref(t)('ダウンロード'),
      "is-disabled-next-button": !startYearMonth.value,
      onOnBack: onCloseDownloadModal,
      onOnNext: onApplyDownload
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('受領用内示ダウンロード')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(t)('開始月')), 1),
              _createVNode(MonthPicker, {
                class: "fof-download__calendar select-month-area__calendar",
                "model-value": startYearMonth.value,
                locale: locale.value,
                "prop-format": 'yyyy / MM',
                "max-date": _unref(DateService).getShiftedIYearMonthFromNowDateByMonths(0),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (startYearMonth.value = $event))
              }, null, 8, ["model-value", "locale", "max-date"])
            ])
          ])
        ])
      ], undefined, true),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button"])
  ], 64))
}
}

})